module.exports = __webpack_public_path__ + "static/media/aws.91a6a247.svg";